// Coordinate del centro dell'Italia (Roma) per centrare la mappa inizialmente
export const centerItalyPosition = [41.9028, 12.4964]; 